export default {
  setList: (state, list) => {
    state.list = [...state.list, ...list];
  },
  setPageInfo: (state, pageInfo) => {
    state.pageInfo = pageInfo;
  },
  setUserNo: (state, { userNo }) => {
    state.condition.userNo = userNo;
  },
  setPage: (state, page) => {
    state.condition.page = page;
  },

  purgeAll: (state) => {
    state.list = [];
    state.pageInfo = { page: 1, totalPage: 2 };
    state.condition = { userNo: 0, page: 1, limit: 10 };
  },
  setTotalCoupon: (state, count) => {
    state.totalCoupon = count;
  }
};
